import { env, toBool } from "./helpers";

/**
 * Determines if PiP is supported.
 */
export function isPipSupported() {
  try {
    return document.pictureInPictureEnabled;
  } catch (error) {
    return false;
  }
}

/**
 * Determines if browser fullscreen is supported.
 */
export function isFullscreenSupported() {
  try {
    return document.fullscreenEnabled;
  } catch (error) {
    return false;
  }
}

/**
 * Determines if the share button is enabled for pages.
 * Sharing is disabled until 100% launch of classroom in app.
 */
export function showShareButton() {
  return toBool(env("ENABLE_SHARE_BUTTON"));
}

/**
 * Determines if the data transfer feature is enabled.
 * This enables the data transfer popup and tab, but does not guarantee their
 * appearance since a user may not have V1 data to migrate.
 * Enabling this also disables the beta tab.
 */
export function isDataTransferFeatureEnabled() {
  return toBool(env("ENABLE_DATA_TRANSFER"));
}
